var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextFieldContentBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 32,
    viewBox: "0 0 45 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C4.31387 0 2.5 1.81387 2.5 4V12C1.396 12 0.5 12.896 0.5 14V18C0.5 19.104 1.396 20 2.5 20V28C2.5 30.1861 4.31387 32 6.5 32H38.5C40.6861 32 42.5 30.1861 42.5 28V20C43.604 20 44.5 19.104 44.5 18V14C44.5 12.896 43.604 12 42.5 12V4C42.5 1.81387 40.6861 0 38.5 0H6.5ZM6.5 4H38.5V12C37.396 12 36.5 12.896 36.5 14V18C36.5 19.104 37.396 20 38.5 20V28H6.5V20C7.604 20 8.5 19.104 8.5 18V14C8.5 12.896 7.604 12 6.5 12V4ZM18.5 8C17.396 8 16.5 8.896 16.5 10C16.5 11.104 17.396 12 18.5 12H20.5V22C20.5 23.104 21.396 24 22.5 24C23.604 24 24.5 23.104 24.5 22V12H26.5C27.604 12 28.5 11.104 28.5 10C28.5 8.896 27.604 8 26.5 8H22.5H18.5Z",
    fill: "#467077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFieldContentBlockIcon);
export default __webpack_public_path__ + "static/media/text-field-content-block-icon.65de35ac2fb4098003f39526dca3a1f6.svg";
export { ForwardRef as ReactComponent };